"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUrlOptions = void 0;
var _auth = require("@ori/auth");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
const useUrlOptions = (basePath, queryParams, host) => {
  const {
    formattedToken
  } = (0, _auth.useToken)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  let query;
  if (queryParams) {
    const params = new URLSearchParams();
    Object.entries(queryParams).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        params.append(key, String(value));
      }
    });
    query = `?${params.toString()}`;
  }
  const usedHost = host ?? window.location.origin;
  const urlOptions = {
    basePath,
    currentLanguage: language,
    formattedToken,
    host: usedHost,
    query,
    tenant
  };
  const cacheKeys = Object.values(urlOptions);
  return {
    cacheKeys,
    urlOptions
  };
};
exports.useUrlOptions = useUrlOptions;